module.exports = __webpack_public_path__ + "static/media/home-icon3.4d8bbc80.svg";